import React from 'react';

interface SensorFusionCuboidsIconProps {
  style?: React.CSSProperties;
}

const SensorFusionCuboidsIcon: React.FC<SensorFusionCuboidsIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Sensor Fusion Cuboids</title>
      <g clipPath="url(#clip0)">
        <path d="M25.98 7.5L12.99 0 0 7.5l12.99.6 12.99-.6z" fill="#6A11EA" />
        <path d="M25.98 7.5H0v15l12.99-6.9 12.99-8.1z" fill="#943CFF" />
        <path d="M25.98 7.5L0 22.5 12.99 30l6.765-10.677L25.98 7.5z" fill="#DD45D3" />
        <path d="M25.98 22.5v-15L12.99 30l12.99-7.5z" fill="#FD9D52" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SensorFusionCuboidsIcon;
